// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__ofjh6","slogan":"style_slogan__IQVhm","actions":"style_actions__jozyU"};